export default __webpack_public_path__ + "static/media/history-icon.38bfefc1.svg";